<ng-container *transloco="let t">
  <div class="d-flex flex-column flex-md-row py-4 align-items-start align-items-md-center justify-content-end">
    @if (backVisible) {
      <div class="pe-3">
        <app-rounded-button [label]="t('app.common.back')"
                            [btnClass]="'rounded-button--black-outline'" (onClick)="back()"/>
      </div>
    }
    @if (cancelVisible) {
      <div class="pe-3 pt-3 pt-md-0">
        <app-rounded-button [label]="t('app.common.cancel')"
                            [btnClass]="'rounded-button--black-outline'" (onClick)="cancel()"/>
      </div>
    }
    <ng-content select="[slot='addNewField']"></ng-content>
    @if (eventPreviewVisible) {
      <div class="pe-3 pt-3 pt-md-0">
        <app-rounded-button [label]="t('event.item.card.preview')"
                            [btnClass]="'rounded-button--red-outline'" (onClick)="goToEventPreview()"
                            [isDisabled]="false"/>
      </div>
    }
    @if (eventMeasurementsVisible) {
    <div class="pe-3 pt-3 pt-md-0">
      <app-rounded-button [label]="t('app.common.measurements')"
                          [btnClass]="'rounded-button--red-outline'" (onClick)="goToEventMeasurements()"
                          [isDisabled]="false"/>
    </div>
    }
    @if (saveVisible) {
      <div class="pt-3 pt-md-0">
        <app-rounded-button [label]="t(saveLabelTranslationKey)"
                            [btnClass]="'rounded-button--solid'" (onClick)="save()"
                            [isDisabled]="disableEditing"/>
      </div>
    }
  </div>
</ng-container>
